import { useParams } from 'react-router';

export const useRouteOrganizationCmId = (): string | undefined => {
  const { organizationCmId } = useParams<'organizationCmId'>();

  return organizationCmId;
};
